import { ConfirmController } from './confirm.controller';
import template from './confirm.html';

export const ConfirmComponent = {
  name: 'confirmComponent',
  restrict: 'E',
  template,
  controller: ConfirmController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<',
    data: '<',
  },
};
